import { AppUrl } from "../config";
import AccountBalance from "@mui/icons-material/AccountBalance";
import { Button, Theme } from "@mui/material";
import * as React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { useHistory } from "react-router-dom";
import { ArrowLeftIcon } from "@mui/x-date-pickers";

const useClasses = makeStyles((theme: Theme) => ({
  landingPageButton: {
    "width": 240,
    "&.MuiButton-root.MuiButton-containedSecondary": {
      marginRight: "2rem",
      marginBottom: "2rem",
    },
  },
  backArrowIcon: {
    margin: 2,
  },
}));

interface Props {
  resetState: (app: string) => void;
  currentApp: string;
}

export default function ReturnToLandingPageButton({
  resetState,
  currentApp,
}: Props) {
  const classes = useClasses();
  const history = useHistory();
  return (
    <Button
      onClick={() => {
        resetState(currentApp);
        history.push(AppUrl("HomePage"));
      }}
      id="return-to-landing-page-button"
      className={classes.landingPageButton}
      variant="contained"
      color="secondary"
      startIcon={
        <>
          <ArrowLeftIcon className={classes.backArrowIcon} fontSize={"large"} />
          <AccountBalance />
        </>
      }
      disableElevation
    >
      BankFind Suite Home
    </Button>
  );
}
